/* @flow */

import moment from 'moment';
import 'moment/locale/pt-br';
import { type Pedido } from '../pedidos/types';
import getEtapaExibida from './get-etapa-da-entrada-exibida';

const getMinutosExibidosNaLista = (pedido: Pedido) => {
    const etapaExibida = getEtapaExibida(pedido);
    return moment(etapaExibida.entrada).fromNow();
};

export default getMinutosExibidosNaLista;
